import React, { PureComponent } from 'react'
import styled from 'styled-components'

import container from './container'
import WorkingHours from './components/workinghours'
import EmailAccounts from './components/emailaccounts'
import Tags from './components/tags'
import Notifications from './components/notifications'
import Apps from './components/apps'
import GipsybotMe from './components/gipsybotme'
import { ReusableButton, media } from 'gipsy-ui'
import { styles, translations } from 'gipsy-misc'
import { marginBottomSection } from 'pages/settings/components/common'

export class Settings extends PureComponent {
  render() {
    const { user, setWeeklyWorkingHours, onLogout, handleAPIError, showErrorSnackbar } = this.props

    return (
      <SettingsContainer>
        <div>
          <h1>{translations.settings.title}</h1>
          <GipsybotMe user={user} />
          <Apps />
          <Notifications user={user} handleAPIError={handleAPIError} />
          <WorkingHours
            weeklyWorkingHours={user.weeklyWorkingHours}
            setWeeklyWorkingHours={setWeeklyWorkingHours}
            showErrorSnackbar={showErrorSnackbar}
            handleAPIError={handleAPIError}
          />
          <EmailAccounts handleAPIError={handleAPIError} />
          <Tags handleAPIError={handleAPIError} />
        </div>

        <LogoutButton onClick={onLogout}>{translations.settings.section.logout.title}</LogoutButton>
      </SettingsContainer>
    )
  }
}

const LogoutButton = styled(ReusableButton)`
  height: 40px;
  width: 110px;
  border-radius: 18px;
  margin-bottom: 40px;
  font-size: ${styles.fonts.fontSizeXSmall};
  background: ${styles.colors.backgroundPrimaryColor};
  box-shadow: 12px 12px 40px 0 rgba(100, 63, 219, 0.24);
`

const SettingsContainer = styled.div`
  position: relative;
  &&& h1 {
    margin-bottom: ${marginBottomSection}px;
  }

  ${media['phone-wide']`
    margin-left: 20px;
    margin-right: 20px;
  `}
`

export default container(Settings)



// WEBPACK FOOTER //
// ./src/pages/settings/index.js